import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import BasketNavButton from "../../../features/NavBar/features/BasketNavButton";

const LimitedTicketGroupPage: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration.componentList);
  const messageGroups = useSelector((state: State) => state.config.configuration.message_groups);

  const { assortGroup, requestGetAssortGroups } = useTickets();

  useEffect(() => {
    requestGetAssortGroups();
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div className="headline">
          {saleConfiguration && (
            <React.Fragment>
              {saleConfiguration.map((item) => (
                <React.Fragment>{item.id === "Groups" && <h1>Wspólny bilet Termy Poddębice ZOO Borysew</h1>}</React.Fragment>
              ))}
            </React.Fragment>
          )}
          <div className="line"></div>

          {messageGroups && (
            <React.Fragment>
              {messageGroups.length > 12 ? (
                <div className="alert alert-comment">
                  <article dangerouslySetInnerHTML={{ __html: messageGroups }}></article>
                </div>
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </React.Fragment>
          )}

        </div>

        {assortGroup && (
          <React.Fragment>
            {assortGroup.map((item, index) => (
              <div key={index}>
                <LimitedTicketBlock item={item} sortType="assortGroup" />
              </div>
            ))}
          </React.Fragment>
        )}
      </div>


      
      <BasketNavButton />

    </React.Fragment>
  );
};

export default LimitedTicketGroupPage;
